'use client';

import React from 'react';
import styled from '@benzinga/themetron';

interface TooltipPopoverProps {
  size?: 'sm' | 'md' | 'lg';
  style?: React.CSSProperties;
  tooltipArrowStyle?: { [key: string]: string };
  placement?: 'top' | 'bottom';
  children?: React.ReactNode;
  className?: string;
}

const TooltipPopover = React.forwardRef<HTMLDivElement, TooltipPopoverProps>(
  ({ children, className = '', placement = 'top', size, style, tooltipArrowStyle }, ref) => (
    <StyledTooltipPopover
      className={`tooltip-popover ${size} ${className}`}
      placement={placement}
      ref={ref}
      role="tooltip"
      style={style}
      tooltipArrowStyle={tooltipArrowStyle}
    >
      {children}
    </StyledTooltipPopover>
  ),
);

export default TooltipPopover;

const StyledTooltipPopover = styled.div<{
  tooltipArrowStyle?: { [key: string]: string };
  placement?: 'top' | 'bottom';
}>`
  &.tooltip-popover {
    padding: 8px;
    background: #333;
    color: white;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.25);
    text-align: center;
    font-size: ${({ theme }) => theme.fontSize.sm};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    z-index: 20;
    position: absolute;
    min-width: 80px;
    max-width: 500px;
    transform: translate3d(0, ${({ placement }) => (placement === 'bottom' ? '4px' : '-4px')}, 0);
    opacity: 1;
    animation: ${({ placement }) => (placement === 'bottom' ? 'tooltip-in-bottom' : 'tooltip-in-top')} 160ms
      cubic-bezier(0.4, 0, 0.2, 1);
    will-change: transform, opacity;

    &:after {
      content: '';
      position: absolute;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #333 transparent transparent transparent;
      ${({ tooltipArrowStyle }) => tooltipArrowStyle && tooltipArrowStyle};
    }
    &.price-pred-tooltip {
      text-align: left !important;
      ul {
        padding-left: 1em;
        list-style: disc;
        margin-left: 1em;
        margin-bottom: 1em;
        ul {
          list-style: circle;
        }
      }
    }
  }

  @keyframes tooltip-in-top {
    from {
      opacity: 0;
      transform: translate3d(0, -10px, 0) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translate3d(0, -4px, 0) scale(1);
    }
  }

  @keyframes tooltip-in-bottom {
    from {
      opacity: 0;
      transform: translate3d(0, 10px, 0) scale(0.98);
    }
    to {
      opacity: 1;
      transform: translate3d(0, 4px, 0) scale(1);
    }
  }
`;
